import { PermissionV1, PermissionV2, principalHasPermission, User } from '@breezy/shared'
import { useMemo } from 'react'
import { usePrincipalUser } from '../../providers/PrincipalUser'

/**
 * @deprecated use useIsAuthorizedTo from targets/web-app/src/hooks/permission/useIsAuthorized.ts instead
 */
export const useIsPrincipalAuthorized = (principal: User | null, to?: PermissionV1 | PermissionV2) => {
  return useMemo(() => {
    if (!principal || !to) return false

    return principalHasPermission(principal, to)
  }, [principal, to])
}

/**
 * @deprecated use useIsAuthorizedTo from targets/web-app/src/hooks/permission/useIsAuthorized.ts instead
 */
export const useIsAuthorizedTo = (to: PermissionV1 | PermissionV2) => {
  const { principal } = usePrincipalUser()
  return useIsPrincipalAuthorized(principal, to)
}
